export const IShareUseCaseType = Symbol('IShareUseCase');
